/**
 * Shell for a consolidated navigation section.
 *
 * Renders the section heading, its tab strip, and the matched sub-route.
 * Replaces the per-page chrome (outer div, "Back to Workspaces" link, <h1>)
 * that was duplicated across the six admin pages.
 */

import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { TabNav } from '@components/ui/TabNav';
import { sectionTabs } from '@utils/navigation';

interface SectionLayoutProps {
  title: string;
  /** The section's own path; used to look up its tabs. */
  sectionPath: string;
  subtitle?: string;
}

export function SectionLayout({
  title,
  sectionPath,
  subtitle,
}: SectionLayoutProps): ReactElement {
  return (
    <div className="section-layout">
      <main className="page-content">
        <h1 className="section-layout__title">{title}</h1>
        {subtitle != null && <p className="section-layout__subtitle">{subtitle}</p>}
        <TabNav tabs={sectionTabs(sectionPath)} ariaLabel={`${title} sections`} />
        <Outlet />
      </main>
    </div>
  );
}
